import React from "react";

export function Loader({ label }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 gap-4" data-testid="loader">
      <div className="w-10 h-10 rounded-full border-2 border-[rgba(212,175,55,0.2)] border-t-[color:var(--cu-gold)] animate-spin" />
      {label && <p className="eyebrow">{label}</p>}
    </div>
  );
}
